import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function ControloQualidadePrivilegios({ user, permissions, setPermissions }) {
  return (
    <>

      <Header header={'Controlo de Qualidade'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeAnalise'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade em Análise '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeAtribuirAnalistaRevisor'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade Atribuir Analista e Revisor'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeRelatorioAnalitico'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade Atribuir Emitir Relatório Análitico'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeEmissaoCertificado'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade Emissão do Certificado'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
